export const ENV = {
  "ENVIRONMENT": "prod",
  "API_URL": "https://prod-apimanagement.carlislehomes.com.au/external/constructionV2/construction/v2/",
  "HEALTH_URL": "https://prod-apimanagement.carlislehomes.com.au/external/constructionV2/construction/v2//",
  "VERSION": "1.1.1"
};


// WEBPACK FOOTER //
// ./src/app/app.env.ts